import { useCallback } from 'react';

import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import { buildCacheRequestSupportPath } from '@/utils/monolithApiRouteService';

const useRequestSupport = (workspaceSlug: string, message: string, onSuccess: () => void = () => {}) => {
  const { mutate, isPending, isError } = useMonolithApiMutation(buildCacheRequestSupportPath(workspaceSlug), 'POST', {
    onSuccess: () => onSuccess(),
  });

  const submit = useCallback(() => {
    mutate({ message });
  }, [message, mutate]);

  return {
    submit,
    isPending,
    isError,
  };
};

export default useRequestSupport;
